export default {
    // 报警消息查询接口
    getAlarmInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarm/getAlarmInfo', params, response);
    },
    // 报警消息删除接口
    deleteAlarmInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarm/deleteAlarmInfo', params, response);
    },
    // 报警级别信息查询接口
    getAlarmLevel(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarm/getAlarmLevel', params, response);
    },
    // 报警类型信息查询接口
    getAlarmEventList(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarm/getAlarmEventList', params, response);
    },
    // 获取报警类型下拉树
    getAlarmTypeTree(params, response) {
        window.vue.$apiAxios.get('/alarm/getAlarmTypeTree', params, response);
    },
    // 查询树形
    findDeviceTree(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceOrgTree', params, response);
    },
    // 搜索设备
    queryDeviceOrgTreeByName(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceOrgTreeByName', params, response);
    },
    // 获取设备类型下拉列表
    getDeviceTypeList(params, response) {
        window.vue.$apiAxios.get('/alarm/getDeviceTypeList', params, response);
    },
    // 导出
    exportAlarmInfo(params, responseType, response) {
        window.vue.$apiAxios.downloadPost('/alarm/exportAlarmInfo', params, responseType, response);
    },
    getMaxLimitCount(params, response) {
        window.vue.$apiAxios.get('/alarm/getMaxLimitCount', params, response);
    },
    // 根据通道id查询中间件、主机信息
    getDeviceInfoByChId(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/external/getDeviceInfoByChId', params, response);
    },
    queryDeviceById(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceById', params, response);
    }
};
